import { defineMessages } from 'react-intl';

export default defineMessages({
    description: {
        id: 'ml.quoteandbind.seperateStructsRented.description',
        defaultMessage: 'Description'
    },
    limit: {
        id: 'ml.quoteandbind.seperateStructsRented.limit',
        defaultMessage: 'Limit'
    },
    structureType: {
        id: 'ml.quoteandbind.seperateStructsRented.structureType',
        defaultMessage: 'Structure Type'
    },
    rentedForResidentialUse: {
        id: 'ml.quoteandbind.seperateStructsRented.rentedForResidentialUse',
        defaultMessage: 'Rented for Residential Use'
    },
    numberOfFamilies: {
        id: 'ml.quoteandbind.seperateStructsRented.numberOfFamilies',
        defaultMessage: 'Number of Families'
    },
    action: {
        id: 'ml.quoteandbind.seperateStructsRented.action',
        defaultMessage: 'Action'
    },
    modalTitle: {
        id: 'ml.quoteandbind.seperateStructsRented.modalTitle',
        defaultMessage: 'Add Separate Structures Rented to Others- On Premises'
    },
    addBtn: {
        id: 'ml.quoteandbind.seperateStructsRented.addBtn',
        defaultMessage: 'Add'
    },
    edit: {
        id: 'ml.quoteandbind.seperateStructsRented.edit',
        defaultMessage: 'Edit'
    },
    remove: {
        id: 'ml.quoteandbind.seperateStructsRented.remove',
        defaultMessage: 'Remove'
    },
    continueBtn: {
        id: 'ml.quoteandbind.seperateStructsRented.continueBtn',
        defaultMessage: 'Continue'
    },
});
